/*
 * The application root: the four providers every screen stands in, and the router.
 *
 * It takes its services rather than reaching for them, so a test renders the whole application
 * against a store it wrote itself, and so `main.tsx` stays the only place that knows how the real
 * store and the real socket are built.
 */

import { RouterProvider, type AnyRouter } from "@tanstack/react-router"
import { StepUpHost } from "./core/auth/index.ts"
import {
	AnnouncerProvider,
	ShellServicesProvider,
	ToastProvider,
	type ShellServices,
} from "./core/shell/index.ts"
import { AccountPreferences } from "./core/shell/preferences.tsx"
import { TooltipProvider } from "./ui/index.ts"

export function App({ services, router }: { services: ShellServices; router: AnyRouter }) {
	return (
		<ShellServicesProvider services={services}>
			<TooltipProvider>
				<AnnouncerProvider>
					<ToastProvider>
						<AccountPreferences />
						<RouterProvider router={router} />
						{/* One step-up prompt for the whole application: any call that is refused
						    with `stepUpRequired` raises this one dialog and is retried once. */}
						<StepUpHost />
					</ToastProvider>
				</AnnouncerProvider>
			</TooltipProvider>
		</ShellServicesProvider>
	)
}
